<div class="filter-container">
  <ng-container #container></ng-container>
  <button class="btn reset-filters btn-40" (click)="clear($event)" *ngIf="filterChanged">
    <span>Reset Filters</span>
  </button>
  <ng-content class="filter-btn" select="[filterBtn]"></ng-content>
  <ng-content  select="[addBtn]"></ng-content>
  <ng-content class="filter-title" select="[filterMessage]"></ng-content>
</div>